import React, { createContext, useContext, useState, useEffect } from "react";
import http from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("st_token");
    if (!token) { setLoading(false); return; }
    http.get("/auth/me", { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("st_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await http.post("/auth/login", { email, password });
    localStorage.setItem("st_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const register = async (username, email, password) => {
    const r = await http.post("/auth/register", { username, email, password });
    localStorage.setItem("st_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem("st_token");
    setUser(null);
  };

  const isHost = user?.role === "host" || user?.role === "admin";
  const isAdmin = user?.role === "admin";

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, isHost, isAdmin }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
